import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TextComponent } from '@app/components/text/text.component';

@Component({
  selector: 'app-header-text',
  templateUrl: './header-text.component.html',
  styleUrl: './header-text.component.scss',
  imports: [
    TextComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderTextComponent {

  public readonly text = input.required<string>();

}
